import { Box, Loader, Stack, Text } from "@mantine/core";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

// Ported from de-payment-admin. The bank consent redirect lands here; relay all
// query params to the opener as BANK_AUTH_DONE, then close. (Adapted to Mantine v9.)
export function BankCallback() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const payload: Record<string, string> = {};
    searchParams.forEach((value, key) => {
      payload[key] = value;
    });

    try {
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage({ type: "BANK_AUTH_DONE", payload }, window.location.origin);
      }
    } catch {
      // cross-origin or no opener — ignore (caller falls back to popup-close detection)
    }

    const timer = setTimeout(() => window.close(), 300);
    return () => clearTimeout(timer);
  }, [searchParams]);

  return (
    <Box mih="100vh">
      <Stack align="center" justify="center" gap="md" mih="100vh">
        <Loader color="brand" />
        <Text size="sm" c="dimmed">Банкны баталгаажуулалт амжилттай. Цонх хаагдаж байна…</Text>
      </Stack>
    </Box>
  );
}

export default BankCallback;
